// ─── JARS FOR SALE — catalog + buy UI ──────────────────────────────────────
// Used by jars.html and packaging.html. No dependency on product-state.js /
// pricing-engine.js / cart-checkout.js. Own defaults copy (mirrors
// admin.html's JARS_DEFAULTS) + reads the same 'vinylpac_jars' localStorage
// key admin.html writes to, so Josh's pricing edits show up immediately.
// Volume tiers match vinylpac.us /collections/premium-jars (pack/case qty →
// $/jar). Known jars link to the source-backed label catalog; custom jars
// use vinylpac_packaging for label pairing.

var JARS_DEFAULTS = {
  products: [
    { id: 'miron-ceres-5ml', name: 'Miron Ceres 5ml Violet Glass Jar',
      unitLabel: 'pack', unitsPerPack: 95, material: 'Miron Violet Glass',
      images: [(window.VP_CDN+"jars_miron_ceres_1.jpg?v=343f0e3b02"), (window.VP_CDN+"jars_miron_ceres_2.jpg?v=56033f68c4"), (window.VP_CDN+"jars_miron_ceres_3.jpg?v=4e0ab09c0c"), (window.VP_CDN+"jars_miron_ceres_4.jpg?v=10d9cc6b04")],
      description: 'Slim 5 ml violet glass jar with a taller profile and narrow mouth — a clean, discreet home for hash rosin, concentrates, and other small-batch extracts. Miron\'s dark violet biophotonic glass blocks visible light while letting beneficial UV and infrared through, extending shelf life and preserving potency.',
      specs: '5 ml capacity · 25.8mm H × 36.1mm W · 29 special thread · fits classic and modern Miron lids',
      tiers: [
        { qty: 1,  pricePerJar: 1.65 },
        { qty: 3,  pricePerJar: 1.60 },
        { qty: 5,  pricePerJar: 1.50 },
        { qty: 53, pricePerJar: 1.45 }
      ]
    },
    { id: 'miron-eris-5ml-cr', name: 'Miron Eris 5ml Violet Glass Jar with Child-Resistant Lid',
      unitLabel: 'pack', unitsPerPack: 90, material: 'Miron Violet Glass (Child-Resistant)',
      images: [(window.VP_CDN+"jars_miron_eris_1.jpg?v=da842fcc6c"), (window.VP_CDN+"jars_miron_eris_2.jpg?v=cadea28e37"), (window.VP_CDN+"jars_miron_eris_3.png?v=afc340c7bd"), (window.VP_CDN+"jars_miron_eris_4.jpg?v=46f8e6efba")],
      description: 'Compact 5 ml violet glass jar with a certified child-resistant lid, made for hash rosin, concentrates, and other potent, light-sensitive extracts. The child-resistant polypropylene lid seals with a 3-layer PHAN liner for a reliable, airtight fit.',
      specs: '5 ml capacity (approx. 2g) · 27.7mm H × 37mm W · 28 special thread · certified child-resistant lid',
      tiers: [
        { qty: 1,  pricePerJar: 1.70 },
        { qty: 3,  pricePerJar: 1.65 },
        { qty: 5,  pricePerJar: 1.55 },
        { qty: 53, pricePerJar: 1.50 }
      ]
    },
    { id: 'black-glass-4oz-cr', name: '4oz Gloss Black Glass Jar with Child-Resistant Lid',
      unitLabel: 'case', unitsPerPack: 32, material: 'Gloss Black Glass (Child-Resistant)',
      images: [(window.VP_CDN+"jars_black_4oz_1.jpg?v=b524584900"), (window.VP_CDN+"jars_black_4oz_2.jpg?v=6070624a35"), (window.VP_CDN+"jars_black_4oz_3.jpg?v=e55cb1dccc")],
      description: '4 oz (40 dram) straight-sided gloss black glass jar with a certified child-resistant lid, sized to hold an eighth (3.5g) of flower. The heavy gloss black glass shields contents from light, and the wide 53-400 mouth makes filling and dispensing easy.',
      specs: '4 oz / 40 dram · 80mm H × 56.9mm W · 53-400 wide mouth · certified child-resistant lid',
      tiers: [
        { qty: 1,   pricePerJar: 1.25 },
        { qty: 5,   pricePerJar: 1.15 },
        { qty: 24,  pricePerJar: 1.05 },
        { qty: 44,  pricePerJar: 0.95 },
        { qty: 64,  pricePerJar: 0.90 },
        { qty: 84,  pricePerJar: 0.85 },
        { qty: 104, pricePerJar: 0.80 }
      ]
    },
    { id: 'miron-saturn-150ml-cr', name: 'Miron Saturn 150ml Violet Glass Jar with Child-Resistant Lid',
      unitLabel: 'case', unitsPerPack: 30, material: 'Miron Violet Glass (Child-Resistant)',
      images: [(window.VP_CDN+"jars_miron_saturn_1.jpg?v=b0b2c24bfe"), (window.VP_CDN+"jars_miron_saturn_2.jpg?v=cbceaefd05")],
      description: 'Wide-neck 150 ml violet glass jar with a certified child-resistant lid, sized to hold a quarter ounce (7g) of flower. Miron\'s dark violet biophotonic glass preserves potency, aroma, and freshness far longer than clear, amber, or standard black glass.',
      specs: '150 ml capacity (7g) · 97.8mm H × 56.8mm W · 53-400 wide mouth · certified child-resistant lid',
      tiers: [
        { qty: 1,  pricePerJar: 3.25 },
        { qty: 11, pricePerJar: 3.15 },
        { qty: 21, pricePerJar: 3.05 },
        { qty: 34, pricePerJar: 2.95 },
        { qty: 41, pricePerJar: 2.90 }
      ]
    }
  ]
};

// Fallback packaging products — mirrors product-state.js PACKAGING_DEFAULTS.
// Used only to pair a jar with wrap+top labels when vinylpac_packaging is empty.
var JARS_PACKAGING_FALLBACK = [
  { name: 'Miron Jar Labels', sizes: [{ id: '5ml', label: '5ml' }, { id: '150ml', label: '150ml' }] },
  { name: 'Flower Jar Labels', sizes: [{ id: '3oz', label: '3 oz' }] }
];

var PACKAGING_PRODUCT_META_JARS = {
  'Miron Jar Labels':  { cat: 'labels',    nav: 'packaging' },
  'Flower Jar Labels': { cat: 'labels',    nav: 'packaging' },
  'Mylar Bags':        { cat: 'packaging' },
  'Pre-Roll Tubes':    { cat: 'packaging' }
};

// Card thumbs: the supplier photos cleaned to pure white with the same crop
// and fill (tools/jar-card-thumbs.py). Galleries keep the original photos.
var JARS_CARD_IMAGES = {
  'miron-ceres-5ml': (window.VP_CDN+"jars-card__miron-ceres-5ml.jpg?v=541a0c9839"),
  'miron-eris-5ml-cr': (window.VP_CDN+"jars-card__miron-eris-5ml-cr.jpg?v=20edc781b8"),
  'black-glass-4oz-cr': (window.VP_CDN+"jars-card__black-glass-4oz-cr.jpg?v=e177a4b02d"),
  'miron-saturn-150ml-cr': (window.VP_CDN+"jars-card__miron-saturn-150ml-cr.jpg?v=ab1b8c3ff3")
};

function jarCardImage(prod) {
  return JARS_CARD_IMAGES[prod.id] || (prod.images || [])[0] || '';
}

function loadJarsConfig() {
  var defaults = JARS_DEFAULTS;
  try {
    var stored = localStorage.getItem('vinylpac_jars');
    if (!stored) return defaults;
    var cfg = JSON.parse(stored);
    if (!cfg || !cfg.products || !cfg.products.length) return defaults;
    var byId = {};
    defaults.products.forEach(function(p) { byId[p.id] = p; });
    cfg.products = cfg.products.map(function(p) {
      var d = byId[p.id] || {};
      var merged = {};
      ['id', 'name', 'unitLabel', 'unitsPerPack', 'material', 'images', 'description', 'specs', 'tiers'].forEach(function(k) {
        var val = p[k];
        var empty = val == null || val === '' || (Array.isArray(val) && !val.length);
        merged[k] = empty ? d[k] : val;
      });
      return merged;
    });
    return cfg;
  } catch (e) { return defaults; }
}

function loadPackagingProductsForJars() {
  try {
    var stored = localStorage.getItem('vinylpac_packaging');
    if (stored) {
      var cfg = JSON.parse(stored);
      if (cfg && cfg.products && cfg.products.length) return cfg.products;
    }
  } catch (e) {}
  return JARS_PACKAGING_FALLBACK;
}

function packagingProductHref(name) {
  var meta = PACKAGING_PRODUCT_META_JARS[name] || { cat: 'packaging' };
  var url = "/?view=configurator&cat=" + encodeURIComponent(meta.cat) +
    '&product=' + encodeURIComponent(name);
  if (meta.nav) url += '&nav=' + encodeURIComponent(meta.nav);
  return url;
}

function packagingProductBlob(p) {
  return ((p.name || '') + ' ' + (p.sizes || []).map(function(s) {
    return (s.id || '') + ' ' + (s.label || '');
  }).join(' ')).toLowerCase();
}

// Pair each jar with the packaging product whose sizes match it, so wrap+top
// links follow whatever Josh set on the Packaging store preferences.
function jarWantSize(prod) {
  var hay = ((prod.id || '') + ' ' + (prod.name || '') + ' ' + (prod.material || '')).toLowerCase();
  if (hay.indexOf('150') !== -1) return '150ml';
  if (hay.indexOf('4oz') !== -1 || hay.indexOf('4 oz') !== -1 || hay.indexOf('40 dram') !== -1) return 'flower';
  if (hay.indexOf('5ml') !== -1 || hay.indexOf('ceres') !== -1 || hay.indexOf('eris') !== -1) return '5ml';
  return null;
}

function matchingPackagingSizeLabel(pair, want) {
  var sizes = pair.sizes || [];
  for (var i = 0; i < sizes.length; i++) {
    var blob = ((sizes[i].id || '') + ' ' + (sizes[i].label || '')).toLowerCase();
    if (want === '150ml' && blob.indexOf('150') !== -1) return sizes[i].label;
    if (want === '5ml' && (blob.indexOf('5ml') !== -1 || blob.indexOf('5 ml') !== -1)) return sizes[i].label;
    if (want === 'flower' && (
      blob.indexOf('flower') !== -1 ||
      blob.indexOf('3 oz') !== -1 || blob.indexOf('3oz') !== -1 ||
      blob.indexOf('4oz') !== -1 || blob.indexOf('4 oz') !== -1 ||
      blob.indexOf('3.5') !== -1 || blob.indexOf('oz') !== -1
    )) return sizes[i].label;
  }
  return sizes.length ? sizes[0].label : null;
}

function findJarLabelPair(prod) {
  var want = jarWantSize(prod);
  if (!want) return null;

  var products = loadPackagingProductsForJars();
  for (var i = 0; i < products.length; i++) {
    var blob = packagingProductBlob(products[i]);
    var hit = false;
    if (want === '150ml' && blob.indexOf('150') !== -1) hit = true;
    if (want === '5ml' && (blob.indexOf('5ml') !== -1 || blob.indexOf('5 ml') !== -1)) hit = true;
    if (want === 'flower' && (
      blob.indexOf('flower') !== -1 ||
      blob.indexOf('3 oz') !== -1 || blob.indexOf('3oz') !== -1 ||
      blob.indexOf('4oz') !== -1 || blob.indexOf('4 oz') !== -1 ||
      blob.indexOf('3.5') !== -1
    )) hit = true;
    if (hit) {
      return {
        name: products[i].name,
        sizeLabel: matchingPackagingSizeLabel(products[i], want)
      };
    }
  }
  return null;
}

var jarsConfig = loadJarsConfig();
var jarSelection = Object.create(null);
var jarActiveId = null;
var jarPageOptions = {};
var jarEditId = null;
var jarEditOriginal = null;
var jarEditError = '';
var jarCartError = '';
var jarSaving = false;
var jarLocationListener = null;
var jarToastTimer = null;

function escHtmlJars(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function jarShortName(product) {
  var names = {
    'miron-ceres-5ml': 'Ceres 5ml',
    'miron-eris-5ml-cr': 'Eris 5ml · CR',
    'black-glass-4oz-cr': 'Black glass 4oz',
    'miron-saturn-150ml-cr': 'Saturn 150ml'
  };
  return names[product.id] || product.name;
}

// Glass line for the card header: "Miron Violet Glass (Child-Resistant)" -> "Miron Violet Glass".
function jarGlassLabel(product) {
  return String(product.material || '').replace(/\s*\(.*?\)\s*/g, ' ').trim();
}

// Spec tiles come straight from the catalog's specs line (admin-editable), one per "·" part.
function jarSpecParts(product) {
  return String(product.specs || '').split('·').map(function(part) {
    part = part.trim();
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).filter(Boolean).slice(0, 4);
}

function jarQuantityLabel(product, qty) {
  var unit = product.unitLabel || 'pack';
  return qty.toLocaleString() + ' ' + unit + (qty > 1 ? 's' : '') + ' · ' +
    (qty * Number(product.unitsPerPack)).toLocaleString() + ' jars';
}

function sortedJarTiers(product) {
  return (product.tiers || []).slice().sort(function(a, b) { return a.qty - b.qty; });
}

// Bracket lookup — identical pattern to pricing-engine.js's tier scan:
// walk ascending tiers, keep the last one whose threshold the qty clears.
function pricePerJarForQty(product, qty) {
  var tiers = sortedJarTiers(product);
  var price = tiers.length ? tiers[0].pricePerJar : 0;
  for (var i = 0; i < tiers.length; i++) {
    if (qty >= tiers[i].qty) price = tiers[i].pricePerJar;
  }
  return price;
}

function fromPricePerJar(product) {
  var tiers = sortedJarTiers(product);
  if (!tiers.length) return 0;
  var lowest = tiers[0].pricePerJar;
  for (var i = 1; i < tiers.length; i++) {
    if (tiers[i].pricePerJar < lowest) lowest = tiers[i].pricePerJar;
  }
  return lowest;
}

function jarQuantity(value) {
  var text = String(value == null ? '' : value).trim();
  var qty = Number(text);
  return /^\d+$/.test(text) && Number.isSafeInteger(qty) && qty > 0 ? qty : null;
}

function jarQuote(prod, value) {
  var qty = jarQuantity(value);
  if (!qty) return null;
  var price = Number(pricePerJarForQty(prod, qty));
  var count = qty * Number(prod.unitsPerPack);
  var total = price * count;
  if (!Number.isSafeInteger(count) || count < 1 || !Number.isFinite(total) || price <= 0 || total > Number.MAX_SAFE_INTEGER / 100) return null;
  return { qty: qty, pricePerJar: price, totalJars: count, total: total, unitPrice: price * Number(prod.unitsPerPack) };
}

function jarProductFromItem(item) {
  if (!item || item.cat !== 'jars') return null;
  var config = item.configuration;
  if (config && config.kind === 'jars') {
    return jarsConfig.products.find(function(p) { return p.id === config.productId; }) || null;
  }
  var type = (item.properties || []).find(function(p) { return p.name === 'Product Type'; });
  return jarsConfig.products.find(function(p) {
    var original = JARS_DEFAULTS.products.find(function(d) { return d.id === p.id; });
    return p.name === item.name || (type && p.name === type.value) ||
      (original && (original.name === item.name || (type && original.name === type.value))) ||
      (item.thumbUrl && (p.images || []).indexOf(item.thumbUrl) !== -1);
  }) || null;
}

function restoreJarEdit() {
  jarEditId = new URLSearchParams(location.search).get('edit');
  jarEditOriginal = null;
  jarEditError = '';
  if (jarEditId === null) return null;
  try {
    var cart = window.VPProductCart ? window.VPProductCart.read() : JSON.parse(sessionStorage.getItem('vp_cart') || '[]');
    var item = cart.find(function(entry) { return String(entry.id) === jarEditId; });
    var prod = jarProductFromItem(item);
    if (!prod) throw new Error('This jar item could not be restored. Your cart has not changed.');
    var qty = jarQuantity(item.configuration && item.configuration.kind === 'jars' ? item.configuration.qty : item.qty);
    if (!qty) throw new Error('This saved quantity could not be restored. Your cart has not changed.');
    jarEditOriginal = { productId: prod.id, qty: qty };
    jarSelection[prod.id] = qty;
    return prod.id;
  } catch (err) {
    jarEditError = err.message || 'Your cart could not be read. Nothing has changed.';
    return null;
  }
}

function jarIdFromLocation() {
  var hashId = '';
  try { hashId = decodeURIComponent(location.hash.replace(/^#jar-detail-/, '')); } catch (err) {}
  var queryId = new URLSearchParams(location.search).get('jar');
  var hashProduct = location.hash.indexOf('#jar-detail-') === 0 && jarsConfig.products.find(function(p) { return p.id === hashId; });
  var queryProduct = jarsConfig.products.find(function(p) { return p.id === queryId; });
  return hashProduct ? hashProduct.id : queryProduct ? queryProduct.id : null;
}

function updateJarLocation() {
  try {
    var url = new URL(location.href);
    url.searchParams.set('jar', jarActiveId);
    if (jarEditId === null) url.searchParams.delete('edit');
    if (url.hash.indexOf('#jar-detail-') === 0) url.hash = '';
    history.replaceState(null, '', url.pathname + url.search + url.hash);
  } catch (err) {}
}

function syncJarEditBanner() {
  var banner = document.getElementById('jarEditBanner');
  var message = document.getElementById('jarEditMessage');
  var cancel = document.getElementById('jarCancelEdit');
  if (banner) banner.hidden = jarEditId === null;
  if (message) message.textContent = jarEditError || 'Editing your cart item. The original stays in your cart until Update Cart succeeds.';
  if (cancel) cancel.disabled = jarSaving;
}

function cancelJarEdit() {
  if (jarSaving) return;
  var original = jarEditOriginal;
  jarEditId = null;
  jarEditOriginal = null;
  jarEditError = '';
  jarCartError = '';
  if (original) {
    jarSelection[original.productId] = original.qty;
    selectJarProduct(original.productId, true, false);
  }
  updateJarLocation();
  syncJarEditBanner();
  syncJarPanel(jarActiveId);
  showJarToast('Edit cancelled. Your original cart item is unchanged.');
}

function renderJarsPage(opts) {
  opts = opts || {};
  var grid = document.getElementById(opts.gridId || 'jarsProdGrid');
  var details = document.getElementById(opts.detailsId || 'jarsDetails');
  if (!grid || (!opts.catalogOnly && !details)) return;
  jarsConfig = loadJarsConfig();
  grid.innerHTML = '';
  if (details) details.innerHTML = '';
  if (!opts.catalogOnly) jarPageOptions = opts;

  jarsConfig.products.forEach(function(prod) {
    if (!Object.prototype.hasOwnProperty.call(jarSelection, prod.id)) {
      var tiers = sortedJarTiers(prod);
      jarSelection[prod.id] = (tiers[0] && jarQuantity(tiers[0].qty)) || 1;
    }
    var unitWord = prod.unitLabel || 'pack';
    var packLine = unitWord.charAt(0).toUpperCase() + unitWord.slice(1) + ' of ' + prod.unitsPerPack +
      ' · From $' + Number(fromPricePerJar(prod)).toFixed(2) + ' / jar';
    var card = document.createElement(opts.catalogOnly ? 'a' : 'button');
    card.className = 'prod-card jar-card';
    card.dataset.jar = prod.id;
    card.id = 'jar-select-' + prod.id;
    if (opts.catalogOnly) {
      card.href = "/?view=jars&jar=" + encodeURIComponent(prod.id);
    } else {
      card.type = 'button';
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute('aria-controls', details.id);
      card.onclick = function() { selectJarProduct(prod.id, false, true); };
      card.addEventListener('keydown', function(event) {
        var cards = Array.from(grid.querySelectorAll('.jar-card'));
        var current = cards.indexOf(card);
        var next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % cards.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current + cards.length - 1) % cards.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = cards.length - 1;
        else return;
        event.preventDefault();
        if (jarSaving) return;
        cards[next].focus();
        selectJarProduct(cards[next].dataset.jar, false, true);
      });
    }
    card.innerHTML =
      '<div class="prod-card-img-wrap photo"><img src="' + escHtmlJars(jarCardImage(prod)) + '" alt=""></div>' +
      '<div class="prod-card-label">' + escHtmlJars(opts.catalogOnly ? prod.name : jarShortName(prod)) + '</div>' +
      (opts.catalogOnly ? '<div class="prod-card-price">' + escHtmlJars(packLine) + '</div>' : '');
    grid.appendChild(card);
  });
  if (opts.catalogOnly) return;

  var editProduct = restoreJarEdit();
  jarActiveId = editProduct || jarIdFromLocation() || jarActiveId || jarsConfig.products[0].id;
  selectJarProduct(jarActiveId, !!editProduct || location.hash.indexOf('#jar-detail-') === 0, false);
  var cancel = document.getElementById('jarCancelEdit');
  if (cancel) cancel.onclick = cancelJarEdit;
  syncJarEditBanner();
  if (!jarLocationListener) {
    jarLocationListener = function() {
      var id = jarIdFromLocation();
      if (id) selectJarProduct(id, true, false);
    };
    window.addEventListener('hashchange', jarLocationListener);
    window.addEventListener('popstate', jarLocationListener);
  }
}

function selectJarProduct(productId, focusPanel, updateUrl) {
  if (jarSaving) return;
  var prod = jarsConfig.products.find(function(p) { return p.id === productId; });
  var details = document.getElementById(jarPageOptions.detailsId || 'jarsDetails');
  var grid = document.getElementById(jarPageOptions.gridId || 'jarsProdGrid');
  if (!prod || !details || !grid) return;
  jarActiveId = productId;
  jarCartError = '';
  grid.querySelectorAll('.jar-card').forEach(function(card) {
    var active = card.dataset.jar === productId;
    card.classList.toggle('active', active);
    card.setAttribute('aria-pressed', String(active));
  });
  var panel = document.createElement('section');
  panel.className = 'jar-detail';
  panel.id = 'jar-detail-' + prod.id;
  panel.setAttribute('aria-labelledby', 'jar-name-' + prod.id);
  var tiers = sortedJarTiers(prod);
  var unit = prod.unitLabel || 'pack';
  var id = escHtmlJars(prod.id);
  var images = prod.images || [];
  var mainSrc = images[0] || '';
  var labelPages = {
    'miron-ceres-5ml': { id: 'miron-5ml-ceres', label: 'Matching top + wrap labels' },
    'miron-eris-5ml-cr': { id: 'miron-5ml-eris', label: 'Matching top + wrap labels' },
    'black-glass-4oz-cr': { id: 'black-4oz', label: '4oz top + wrap labels' },
    'miron-saturn-150ml-cr': { id: 'miron-150ml', label: 'Miron 150ml top + wrap labels' }
  };
  var labelPage = labelPages[prod.id];
  var pair = labelPage ? null : findJarLabelPair(prod);
  var pairHTML = '';
  if (labelPage) {
    pairHTML = "<div class=\"jar-label-pair\"><a href=\"/?view=jar-labels&jar=" + labelPage.id + '">' +
      ("<img src=\""+window.VP_CDN+"jar-labels__strip-") + labelPage.id + '.jpg' + (labelPage.id === 'black-4oz' ? '?v=20261010-closed' : '') + '" alt="" width="56" height="56">' +
      '<span><strong>Make them yours</strong><small>' + labelPage.label + ' · sold separately</small></span>' +
      '<span class="jar-label-pair-arrow" aria-hidden="true">→</span></a></div>';
  } else if (pair) {
    pairHTML = '<div class="jar-label-pair jar-label-pair-plain">Custom labels: <a href="' + escHtmlJars(packagingProductHref(pair.name)) + '">' +
      escHtmlJars(pair.name + (pair.sizeLabel ? ' (' + pair.sizeLabel + ')' : '')) + '</a>. Confirm the jar fit before ordering.</div>';
  }
  var facts = jarSpecParts(prod);
  var factsHTML = facts.length ? '<ul class="jar-facts" aria-label="Specifications">' + facts.map(function(fact) {
    return '<li>' + escHtmlJars(fact) + '</li>';
  }).join('') + '</ul>' : '';
  // Quantity lives on the card (Oct 8, Josh: no popup): a pack stepper for any count,
  // plus the volume breaks as one-tap shortcuts.
  var unitWord = function(n) { return unit + (n === 1 ? '' : 's'); };
  var ladderHTML = tiers.length > 1 ? '<div class="jar-ladder"><p class="jar-ladder-head"><span>Volume pricing</span><span class="jar-ladder-next" data-jar-next aria-live="polite"></span></p>' +
    '<div class="jar-ladder-steps" role="group" aria-label="Volume price breaks">' + tiers.map(function(t) {
      var q = Number(t.qty);
      return '<button type="button" class="jar-ladder-step" data-qty="' + escHtmlJars(t.qty) + '" aria-pressed="false" aria-label="' +
        escHtmlJars(q.toLocaleString() + ' or more ' + unitWord(q) + ', $' + Number(t.pricePerJar).toFixed(2) + ' per jar') + '">' +
        '<strong>$' + Number(t.pricePerJar).toFixed(2) + '</strong><span>' + escHtmlJars(q.toLocaleString()) + '+' + (tiers.length <= 5 ? ' ' + escHtmlJars(unitWord(q)) : '') + '</span></button>';
    }).join('') + '</div></div>' : '';
  var glass = jarGlassLabel(prod);
  panel.innerHTML = '<div class="jar-detail-inner">' +
    '<div class="jar-detail-gallery"><div class="jar-detail-img-wrap"><img id="jar-main-img-' + id + '" src="' + escHtmlJars(mainSrc) + '" alt="' + escHtmlJars(prod.name) + '"></div></div>' +
    '<div class="jar-detail-options">' +
      '<div class="jar-head"><div class="jar-head-text"><h2 class="jar-detail-name" id="jar-name-' + id + '" tabindex="-1">' + escHtmlJars(jarShortName(prod)) + '</h2>' +
        '<p class="jar-pack-info">' + (glass ? escHtmlJars(glass) + ' · ' : '') + '<strong>' + escHtmlJars(Number(prod.unitsPerPack).toLocaleString()) + ' jars</strong> per ' + escHtmlJars(unit) + '</p></div>' +
        '<p class="jar-head-price" aria-hidden="true"><strong data-jar-each></strong><span>/ jar</span></p></div>' +
      factsHTML +
      '<div class="jar-qty-row"><div class="jar-qty-label"><label for="jar-qty-' + id + '">Quantity</label><span data-jar-qty-value></span></div>' +
        '<div class="jar-stepper"><button type="button" class="jar-step-btn" data-jar-step="-1" aria-label="One fewer ' + escHtmlJars(unit) + '">−</button>' +
          '<input id="jar-qty-' + id + '" type="number" min="1" step="1" inputmode="numeric" required class="jar-custom-input" data-jar="' + id + '" aria-describedby="jar-qty-error-' + id + '">' +
          '<button type="button" class="jar-step-btn" data-jar-step="1" aria-label="One more ' + escHtmlJars(unit) + '">+</button></div></div>' +
      '<p class="jar-error" id="jar-qty-error-' + id + '" data-jar-error role="status" hidden></p>' + ladderHTML +
      '<div class="jar-summary"><div class="jar-summary-price" data-jar-summary="' + id + '" aria-live="polite" aria-atomic="true"></div>' +
        '<button type="button" class="btn-jar-add" data-jar-add="' + id + '">Add to Cart</button></div>' +
      '<p class="jar-error" data-jar-cart-error role="alert" hidden></p>' + pairHTML + '</div></div>';
  var productDetails = document.createElement('details');
  productDetails.className = 'jar-product-details';
  productDetails.innerHTML = '<summary>Product details &amp; specifications</summary><div class="jar-product-details-body">' +
    '<h3>' + escHtmlJars(prod.name) + '</h3><p class="jar-detail-desc">' + escHtmlJars(prod.description) + '</p>' +
    '<p class="jar-detail-specs">' + escHtmlJars(prod.specs || '') + '</p></div>';
  details.replaceChildren(panel, productDetails);
  var input = panel.querySelector('.jar-custom-input');
  function setJarQty(qty) {
    jarSelection[prod.id] = qty;
    input.value = qty;
    jarCartError = '';
    syncJarPanel(prod.id);
  }
  input.value = jarSelection[prod.id];
  input.addEventListener('input', function() {
    jarSelection[prod.id] = input.value;
    jarCartError = '';
    syncJarPanel(prod.id);
  });
  panel.querySelectorAll('[data-jar-step]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setJarQty(Math.max(1, (jarQuantity(input.value) || 0) + Number(btn.dataset.jarStep)));
    });
  });
  panel.querySelectorAll('.jar-ladder-step').forEach(function(btn) {
    btn.addEventListener('click', function() { setJarQty(Number(btn.dataset.qty)); });
  });
  panel.querySelector('[data-jar-add]').addEventListener('click', function() { addJarToCart(prod.id); });
  syncJarPanel(prod.id);
  if (window.vpJarBuilderPreview) window.vpJarBuilderPreview.syncJar(prod.id);
  if (updateUrl) updateJarLocation();
  if (focusPanel) panel.querySelector('.jar-detail-name').focus({ preventScroll: true });
}

function syncJarPanel(productId) {
  var prod = jarsConfig.products.find(function(p) { return p.id === productId; });
  var panel = document.getElementById('jar-detail-' + productId);
  if (!prod || !panel) return;
  var quote = jarQuote(prod, jarSelection[productId]);
  var unit = prod.unitLabel || 'pack';
  var input = panel.querySelector('.jar-custom-input');
  var error = panel.querySelector('[data-jar-error]');
  panel.querySelector('[data-jar-qty-value]').textContent = quote ? jarQuantityLabel(prod, quote.qty) : 'Enter a number of ' + unit + 's';
  var cartError = panel.querySelector('[data-jar-cart-error]');
  input.setAttribute('aria-invalid', String(!quote));
  input.disabled = jarSaving;
  error.hidden = !!quote;
  error.textContent = quote ? '' : 'Enter a whole number of ' + unit + 's (1 or more).';
  cartError.hidden = !jarCartError;
  cartError.textContent = jarCartError;
  panel.querySelectorAll('[data-jar-step]').forEach(function(btn) {
    btn.disabled = jarSaving || (Number(btn.dataset.jarStep) < 0 && (!quote || quote.qty <= 1));
  });
  var grid = document.getElementById(jarPageOptions.gridId || 'jarsProdGrid');
  if (grid) grid.querySelectorAll('button.jar-card').forEach(function(btn) { btn.disabled = jarSaving; });
  var summary = panel.querySelector('[data-jar-summary]');
  summary.innerHTML = quote ? '<span>Total</span><strong>$' + quote.total.toFixed(2) + '</strong>' +
    '<small>' + quote.totalJars.toLocaleString() + ' jars · $' + quote.pricePerJar.toFixed(2) + '/jar</small>' : 'Choose a valid quantity to see your total.';
  var activeTier = null, nextTier = null;
  sortedJarTiers(prod).forEach(function(t) {
    if (quote && quote.qty >= t.qty) activeTier = Number(t.qty);
    else if (quote && !nextTier) nextTier = t;
  });
  panel.querySelectorAll('.jar-ladder-step').forEach(function(step) {
    var on = activeTier !== null && Number(step.dataset.qty) === activeTier;
    step.classList.toggle('on', on);
    step.setAttribute('aria-pressed', String(on));
    step.disabled = jarSaving;
  });
  var next = panel.querySelector('[data-jar-next]');
  if (next) {
    var more = nextTier ? Number(nextTier.qty) - quote.qty : 0;
    next.textContent = !quote ? '' : nextTier ? 'Add ' + more + ' more ' + unit + (more === 1 ? '' : 's') + ' → $' + Number(nextTier.pricePerJar).toFixed(2) + '/jar' : 'Best price unlocked';
  }
  var each = panel.querySelector('[data-jar-each]');
  if (each) each.textContent = '$' + (quote ? quote.pricePerJar : pricePerJarForQty(prod, 1)).toFixed(2);
  var add = panel.querySelector('[data-jar-add]');
  add.disabled = !quote || jarSaving || !!jarEditError;
  add.textContent = jarSaving ? 'Saving…' : jarEditId !== null ? 'Update Cart' : 'Add to Cart';
  panel.setAttribute('aria-busy', String(jarSaving));
  syncJarEditBanner();
}

function showJarToast(message) {
  var toast = document.getElementById('jarAddedToast');
  if (!toast) return;
  clearTimeout(jarToastTimer);
  toast.textContent = message;
  toast.classList.add('show');
  jarToastTimer = setTimeout(function() { toast.classList.remove('show'); }, 4000);
}

async function addJarToCart(productId) {
  if (jarSaving || jarEditError) return null;
  var prod = jarsConfig.products.find(function(p) { return p.id === productId; });
  var quote = prod && jarQuote(prod, jarSelection[productId]);
  if (!quote || productId !== jarActiveId) {
    syncJarPanel(productId);
    return null;
  }
  var qty = quote.qty;
  var unit = prod.unitLabel || 'pack';
  var item = {
    name: prod.name,
    qty: qty,
    unitPrice: quote.unitPrice.toFixed(2),
    total: quote.total.toFixed(2),
    properties: [
      { name: 'Product Type', value: prod.name },
      { name: 'Material', value: prod.material },
      { name: 'Size', value: qty + ' ' + unit + (qty > 1 ? 's' : '') + ' (' + prod.unitsPerPack + ' jars/' + unit + ')' },
      { name: 'Finish', value: '—' },
      { name: 'Specialty Finish', value: 'None' },
      { name: 'Artwork File', value: '(none)' },
      { name: 'Preview Image', value: '(product photo — no custom artwork)' },
      { name: 'Unit Price', value: '$' + quote.unitPrice.toFixed(2) },
      { name: 'Special Notes', value: qty + ' ' + unit + (qty > 1 ? 's' : '') + ' × ' + prod.unitsPerPack + ' jars = ' + quote.totalJars + ' jars @ $' + quote.pricePerJar.toFixed(2) + '/jar' }
    ],
    cat: 'jars',
    configuration: { version: 1, kind: 'jars', productId: prod.id, qty: qty },
    artworkFile: '(none)',
    artworkThumb: '',
    thumbUrl: (prod.images || [])[0] || ''
  };
  var editing = jarEditId !== null;
  jarSaving = true;
  jarCartError = '';
  syncJarPanel(productId);
  try {
    if (!window.VPProductCart || typeof window.VPProductCart.commit !== 'function') throw new Error('Cart storage is unavailable. Please reload and try again.');
    var saved = await window.VPProductCart.commit(item, null, jarEditId);
    try {
      var cart = window.VPProductCart.read();
      var badge = document.getElementById('cartBadge');
      if (badge) { badge.textContent = cart.length; badge.style.display = cart.length ? 'inline-flex' : 'none'; }
      if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer();
    } catch (error) { /* The cart is committed even if its display cannot refresh. */ }
    jarEditId = null;
    jarEditOriginal = null;
    jarEditError = '';
    updateJarLocation();
    showJarToast(editing ? 'Cart updated.' : qty + '× ' + prod.name + ' added to cart!');
    return saved;
  } catch (err) {
    jarCartError = (editing ? 'Update failed. Your original cart item is unchanged. ' : 'Not added to cart. ') +
      (err.message || 'Please try again.');
    return null;
  } finally {
    jarSaving = false;
    syncJarPanel(productId);
  }
}
